import type { Theme } from "@emotion/react";
import { css } from "@emotion/react";

import * as dimensions from "@styles/emotion-styles/dimensions";
import * as layers from "@styles/emotion-styles/layers";

export const dialog = (theme: Theme) => css`
  z-index: ${layers.indexDrawerMax};
  background-color: ${theme.surface.level1};

  > .MuiDrawer-paper {
    height: 100%;

    > section > div {
      height: 100%;
    }
  }
`;

export const container = (theme: Theme) => css`
  height: 100vh;
  background-color: ${theme.surface.level1};
`;

export const header = css`
  padding: 2rem 1rem 1rem 1rem;

  && > h2 {
    margin-bottom: 0;
  }
`;

export const smallHeader = css`
  padding: 1.5rem 1rem 1rem 1rem;
`;

export const stickyContainer = css`
  height: auto;
`;

export const stickyHeader = (theme: Theme) => css`
  position: sticky;
  top: 0;
  background-color: ${theme.system.backgroundBase};
  z-index: ${layers.indexRxStickyFooter};
  border-bottom: 1px solid ${theme.system.borderBase};
  padding: 1rem;
`;

export const accordionFilters = css`
  padding-bottom: 5rem;

  & > * {
    margin: 0.25rem 1rem 0.25rem 1rem;

    label:has(input[type="checkbox"]) {
      margin-left: 0.125rem;
    }
  }

  & > *::before {
    position: absolute;
    width: 92%;
    margin: 0 4%;
  }

  @media screen and (min-width: ${dimensions.phone}) {
    & > *::before {
      width: 94%;
      margin: 0 3%;
    }
  }

  @media screen and (min-width: ${dimensions.phoneLarge}) {
    & > *::before {
      width: 96%;
      margin: 0 2%;
    }
  }
`;
